<template>
  <v-app-bar
    app
    clipped-left
    fixed
  >
    <v-btn icon @click="$router.go(-1)">
      <v-icon>mdi-keyboard-backspace</v-icon>
    </v-btn>
    <v-toolbar-title>{{ $t(title) }}</v-toolbar-title>
    <v-spacer></v-spacer>
    
  </v-app-bar>
</template>

<script>
export default {
  data: () => ({
    drawer: null,
  }),
  props: ['title']
}
</script>

<style>

</style>